<template>
  <div id="ChargeSheet">
          <div class="row">
            <div class="col-12">
              <MdTitleRegInfo
                v-bind:RegistrationInfo="PatientTitle"
                v-bind:titlePrefix="$t('ChargeSheet.EditChargeSheet')"
                v-bind:IsClinical="false"
                v-bind:titleRef="'titleElementPatientClaim'"
                v-bind:patientCode="this.$route.params.id">
              </MdTitleRegInfo>
            </div>
           </div>
            <div class="ChargeSheetContainerBox noNum mt-2">
            <div class="row">
            <div class="col-md-12">
                <div class="grid-margin stretch-card">
                <div class="card activeCard">
                    <div class="card-body">
                    <div
                        class="d-flex align-items-start justify-content-between">
                        <h6 v-b-toggle="'InfoBoxs'" class="card-title flex-grow lower-line text-truncate">
                          {{ $t('PatientClaimList.AditionalInformation') }}
                        </h6>
                        </div>
                        <b-collapse visible id="InfoBoxs" class="small-info ml-2"><small>{{$t('ChargeSheet.clickTitleTextChargeSheet')}}</small></b-collapse>
                    <b-collapse id="InfoBoxs">



                        <div class="card activeCard">
                            <div class="container-mars">
                                <div class="card-container">
                                    <div class="card-body">
                                        <div class="row patPhoto-container">
                                            <div class="col-md-12">
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.MrNo') }}</small><br>
                                                        <b>{{ patientCode }}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.AccountNo') }}</small><br>
                                                        <b>{{chartNo}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.AdmDate') }}</small><br>
                                                        <b>{{AdmDate}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.AdmTime') }}</small><br>
                                                        <b>{{AdmTime}}</b>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.DiscDate') }}</small><br>
                                                        <b>{{DiscDate}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.DiscTime') }}</small><br>
                                                        <b>{{DiscTime}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.ReferenceNo') }}</small><br>
                                                        <b>{{admissionRecordID}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.PatientName') }}</small><br>
                                                        <b>{{PatientTitle.fullName}}</b>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.DaysLpf') }}</small><br>
                                                        <b>{{dayinIPF}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.PrimDiag') }}</small><br>
                                                        <b>{{primDiag}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.RoomNumber') }}</small><br>
                                                        <b>{{roomNo}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.PatientAddress') }}</small><br>
                                                        <b>{{patientAddress}}</b>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.DoctorName') }}</small><br>
                                                        <b>{{doctorName}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.Zip') }}</small><br>
                                                        <b>{{patientZIP}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.City') }}</small><br>
                                                        <b>{{patientCity}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.State') }}</small><br>
                                                        <b>{{patientState}}</b>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.Age') }}</small><br>
                                                        <b>{{PatientTitle.age}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.SSN') }}</small><br>
                                                        <b>{{maskedSSN}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.Gender') }}</small><br>
                                                        <b>{{gender}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Shared.InsuranceCode') }}</small><br>
                                                        <b>{{facilityCode}}</b>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.InsuranceCompany') }}</small><br>
                                                        <b>{{insuranceCompany}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('ChargeSheet.PrimInsuranceNo') }}</small><br>
                                                        <b>{{primInsurance}}</b>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </b-collapse>
                    </div>
                </div>
                </div>
            </div>
            </div>
         </div>


        <MdTabList v-bind:TabList="tablist" v-bind:ShowTabList="false">
            <div class="tab-content tab-content-no-padding tab-content-custom-pill" id="pills-tabContent-custom">
                <div class="tab-pane fade show active" id="Detail" role="tabpanel">
                    <MdEditableGrid
                        :ref="'editableGrid'"
                        :columns="columnsDetail"
                        :rows="detail"
                        :showMessageIsEmpty="ShowMessageIsEmpty"
                        :serverSidePagination="true"
                        :showAdd="true"
                        :showDelete="false"
                        :showSelectAll="false"
                        :showSearch="true"
                        :totalRows="totalDetailRows"
                        :currentPage="currentDetailPage"
                        :perPage="perDetailPage"
                        :pageOptions="pageOptions"
                        :pageChanged="pageDetailChanged"
                        :perPageFunction="PerPageDetailFunction"
                        :appendNewRows="appendDetailRows"
                        :addActionButton="addActionButton"
                        :deleteActionButton="deleteDetailActionButton"
                        :dataKey="'recNo'"
                        @cell-edit-complete="onDetailCellEditComplete"
                        @search="onDetailSearch"
                        @select-row="onRowDetailSelected"
                    >
                    </MdEditableGrid>
                </div>
                <div class="tab-pane fade show" id="Summary" role="tabpanel">
                    <MdTable
                        v-bind:fields="fieldsSummary"
                        v-bind:items="summary"
                        v-bind:totalRows="totalSummaryRows"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                        v-bind:currentPage="currentSummaryPage"
                        v-bind:perPage="perSummaryPage"
                        v-bind:pageOptions="pageOptions"
                        v-bind:refTable="'tablesummary'"
                        :onRowSelected="onRowSummarySelected"
                        :onFiltered="onSummaryFiltered"
                        :pageChanged="pageSummaryChanged"
                        :perPageFunction="PerPageSummaryFunction">
                    </MdTable>
                </div>
                <div class="tab-pane fade show" id="Actions" role="tabpanel">
                    <MdTable
                        v-bind:fields="fieldsActions"
                        v-bind:items="actions"
                        v-bind:totalRows="totalActionsRows"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                        v-bind:currentPage="currentActionsPage"
                        v-bind:perPage="perActionsPage"
                        v-bind:pageOptions="pageOptions"
                        v-bind:refTable="'tableactions'"
                        :onRowSelected="onRowActionsSelected"
                        :onFiltered="onActionsFiltered"
                        :pageChanged="pageActionsChanged"
                        :perPageFunction="PerPageActionsFunction"
                        @select-row="onSelectRow">
                    </MdTable>
                </div>
            </div>
        </MdTabList>

        <div class="space-actions"></div>
         <div class="page-actions">
        <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:Name="'btnpatientlist'"
            v-bind:ClassProp="'secondary mx-2 btn-login'"
            v-on:click="DiscardChanges"/>
        <b-dropdown id="dropdown-dropup" dropup :text="$tc('Shared.ActionsTxt',2)" variant="primary" class="m-2">
          <b-dropdown-item-button
            v-on:click="onClickAddProcedures()">
            {{$t('ChargeSheet.AddProcedures')}}
          </b-dropdown-item-button>

          <b-dropdown-item-button
            v-on:click="onClickResetRoomCharge()">
            {{$t('ChargeSheet.ResetRoomCharges')}}
          </b-dropdown-item-button>

          <b-dropdown-item-button
            v-on:click="onClickBillReport('N')">
            {{$t('ChargeSheet.BillableReport')}}
          </b-dropdown-item-button>

          <b-dropdown-item-button
            v-on:click="onClickBillReport('Y')">
            {{$t('ChargeSheet.BilledReport')}}
          </b-dropdown-item-button>

          <b-dropdown-item-button
            v-on:click="onClickGenerateClaims()">
            {{$t('ChargeSheet.GenerateClaims')}}
          </b-dropdown-item-button>

          <b-dropdown-item-button
            v-on:click="saveEditableGrid()">
            {{$t('Shared.Save')}}
          </b-dropdown-item-button>
        </b-dropdown>
    </div>

    <ModalAddProcedures  v-if="isAddProceduresVisible"
        :visible="isAddProceduresVisible"
        @close="closeModalAddProcedures"
        v-bind:recordId="admissionRecordID"
        v-bind:admissionADMITDATE="patientInfo[0].admissionADMITDATE"
        v-bind:admissionDischargeDate="patientInfo[0].admissionDISCHARGEDATE"
    />

    <ChargeSheetRep v-if="isReportVisible"
      :visible="isReportVisible"
      @close="closeParamRepWindow"
      :patientCode="this.$route.params.id"
      :billed="isBillableReport"
      :title="isBillableReport == 'Y' ? $t('ChargeSheet.TitleBilled') : $t('ChargeSheet.TitleBillable')"
      :groupCreationID="admissionRecordID"
      :dateFrom="AdmDate"
      :dayinIPF="Number(dayinIPF)"
      />

    <BaseModal 
        v-if="ClaimBatchVisible"
        ModalId="ModalClaimBatch"
        :key="'ModalClaimBatch'"
        :TitleWindow="'Batch Billing'"
        :width="'70%'"
        :height="'85vh'"
        :UseUpClass="true"
        :HideModalFun="ClaimBatchOnCancel"
        @Close="ClaimBatchOnCancel"
        :buttons="[
            { text: 'Validate', variant: 'primary', action: ValidateBatch },
            { text: 'Batch', variant: 'primary', action: ProcessBatch },
        ]">

        <ClaimBatchProcessing 
            ref="mdClaimBatchProcessing"
            :Items="this.ClaimBatchItems" />
    </BaseModal>

  </div>
</template>

<script>
    import ChargeSheetService from '@/services/chargesheet.service'
    import AttendancesService from '@/services/attendances.service'
    import ShowMessage from '@/components/messages/ShowMessage.js';
    import DBFunctions from '@/common/DBFunctions.js';
    import Utils from "@/common/utils";
    import ClaimBatchProcessing from '@/components/MedEZComponents/claims/ClaimBatchProcessing.vue';

    export default {

        beforeRouteLeave(to, from, next) {
        if (this.pendingChanges) {
            this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
            title: this.$tc('ChargeSheet.ChargeSheet'),
            okTitle: this.$t('Shared.BtnCancel'),
            cancelTitle: this.$t('Shared.BtnDismiss'),
            footerClass: 'p-2',
            titleClass: 'modal-title modal-type-warning'
            })
            .then(value => {
                if(!value){
                    next();
                }
            })
        } else {
            next()
        }
        },
        mixins: [ShowMessage, DBFunctions],
        components: {ClaimBatchProcessing},
        name: 'ChargeSheetDetail',
        data(){
        return {
          items:[],
          ClaimBatchItems: [],
          Header:{},
          HeaderSummary: {},
          HeaderActions: {},
          HeaderDetail: {},
          SearchCriteria:"",
          ShowMessageIsEmpty:false,
          pageOptions: [5,10,20,30,40,50],
          totalRows: 0,
          totalSummaryRows: 0,
          totalActionsRows: 0,
          totalDetailRows: 0,
          currentPage: 1,
          currentSummaryPage: 1,
          currentActionsPage: 1,
          currentDetailPage: 1,
          perPage: 10,
          perSummaryPage: 10,
          perActionsPage: 10,
          perDetailPage: 10,
          OptionsRightMenu:{
              visible:false,
              ItemsList:[],
              btnvisible:false,
              itemdisabled: false,
              favButtonAtion:false
            },

           fields: [
            { key: 'patientcode', sortable: true, label: 'Patient Code', class: 'text-rigth' },
            { key: 'patientName', sortable: true, label: 'Patient Name', class: 'text-rigth' },
            { key: 'admitdate', sortable: true, label: 'Admit Date', class: 'text-rigth' },
            { key: 'admittime', sortable: true, label: 'Admit Time', class: 'text-rigth' },
            { key: 'dischargedate', sortable: true, label: 'Discharge Date', class: 'text-rigth' },
            { key: 'dischargetime', sortable: true, label: 'Discharge Time', class: 'text-rigth' },
            { key: 'roomno', sortable: true, label: 'Room', class: 'text-rigth' },
            { key: 'admissionsource', sortable: true, label: 'SRC', class: 'text-rigth' },
            { key: 'admissiontype', sortable: true, label: 'Type', class: 'text-rigth' },
            { key: 'programcode', sortable: true, label: 'Program', class: 'text-rigth' },
            { key: 'minServiceDate', sortable: true, label: 'Service Date From', class: 'text-rigth' },
            { key: 'maxServiceDate', sortable: true, label: 'Service Date To', class: 'text-rigth' },
            { key: 'company', sortable: true, label: 'Company', class: 'text-rigth' },
          ],
          fieldsSummary: [
            { key: 'dateFrom', sortable: true, label: this.$t('Shared.datefrom'), class: 'text-rigth' },
            { key: 'dateTo', sortable: true, label: this.$t('Shared.dateTo'), class: 'text-rigth' },
            { key: 'unit', sortable: true, label: this.$t('Shared.Unit'), class: 'text-rigth' },
            { key: 'unitPrice', sortable: true, label: this.$t('Shared.UnitPrice'), class: 'text-rigth' },
            { key: 'total', sortable: true, label: this.$t('Shared.Total'), class: 'text-rigth' },
            { key: 'cpt', sortable: true, label: this.$t('Shared.CPT'), class: 'text-rigth' },
            { key: 'billed', sortable: true, label: this.$t('modalClaimDetail.Billed'), class: 'text-rigth' },
            { key: 'description', sortable: true, label: this.$t('Shared.Description'), class: 'text-rigth' },
          ],
          fieldsActions: [
            { key: 'actionDate', sortable: true, label: this.$t('Shared.ActionDate'), class: 'text-rigth' },
            { key: 'action', sortable: true, label: this.$tc('Shared.ActionsTxt',2), class: 'text-rigth' },
            { key: 'dateFrom', sortable: true, label: this.$t('Shared.datefrom'), class: 'text-rigth' },
            { key: 'dateTo', sortable: true, label: this.$t('Shared.dateTo'), class: 'text-rigth' },
            { key: 'oldValue', sortable: true, label: this.$t('Shared.OldValue'), class: 'text-rigth' },
            { key: 'newValue', sortable: true, label: this.$t('Shared.NewValue'), class: 'text-rigth' },
            { key: 'userName', sortable: true, label: this.$t('Shared.UserName'), class: 'text-rigth' },
          ],
          columnsDetail: [
            {
              key: 'servicedate',
              label: this.$t('Shared.ServiceDate'),
              dataType: 'date',
              editable: true
            },
            {
              key: 'unit',
              label: this.$t('Shared.Unit'),
              dataType: 'numeric',
              props: { inputType: 'decimal' }
            },
            {
              key: 'coursecode',
              label: `${this.$t('Shared.Description')}`,
              dataType: 'lookup',
              props: {
                api: 'Therapies/LookUp',
                fieldCode: 'code',
                fieldDescription: 'description',
                valueDescription: 'description',
                searchTitle: this.$t('Shared.SearchElements'),
                fields: [
                  { key: 'description', label: this.$t('Shared.Description') },
                  { key: 'code', label: this.$t('Shared.Code') }
                ]
              }
            },
            {
              key: 'unitPrice',
              label: this.$t('Shared.UnitPrice'),
              dataType: 'numeric',
              formatter: (v) => v != null ? `$${Number(v).toFixed(2)}` : '',
              props: { inputType: 'decimal' }
            },
            {
              key: 'total',
              label: this.$t('Shared.Total'),
              dataType: 'numeric',
              editable: false,
              formatter: (v) => v != null ? `$${Number(v).toFixed(2)}` : '',
              props: { inputType: 'decimal' }
            },
            {
              key: 'billed',
              label: this.$t('modalClaimDetail.Billed'),
              editable: false
            },
            {
              key: 'roomno',
              label: this.$t('ChargeSheet.RoomNumber'),
              dataType: 'lookup',
              props: {
                api: 'Rooms/Summary',
                fieldCode: 'code',
                fieldDescription: 'roomAndBuildingName',
                valueDescription: 'roomDescription',
                searchTitle: this.$t('ChargeSheet.RoomNumber'),
                fields: [
                  { key: 'code', label: this.$t('Shared.Code') },
                  { key: 'roomAndBuildingName', label: this.$t('Shared.Description') }
                ]
              }
            }
          ],
          deleteDetailActionButton: {
            visible: true,
            handler: this.deleteItem
          },
          addActionButton: {
            handler: this.addItem
          },
          DetailSearchCriteria: '',
          showMessageIsEmpty: false,
          PatientTitle:{
            programName:'',
            fullName:'',
            admitDate:'',
            dischargeDate:'',
            dob:'',
            activitytypename:'',
            startdatetime:'',
            ageFormatted:''
          },
          patientCode: '',
          patientAddress: '',
          patientZIP: '',
          patientCity: '',
          patientState: '',
          facilityCode: '',
          primInsurance: '',
          insuranceCompany: '',
          gender: '',
          maskedSSN: '',
          doctorName: '',
          roomNo: '',
          primDiag: '',
          dayinIPF: '',
          admissionRecordID: '',
          chartNo: '',
          AdmDate: null,
          AdmTime: null,
          DiscDate: null,
          DiscTime: null,
          patientInfo: [],
          tablist: [
            { title: this.$t('Shared.Detail'), link: '#Detail', active: true},
            { title: this.$t('Shared.Summary'), link: '#Summary'},
            { title: this.$t('Shared.History'), link: '#Actions'},
          ],
          summary: [],
          actions: [],
          detail: [],
          detailSelected: [],
          isAddProceduresVisible: false,
          showCMD: false,
          isReportVisible: false,
          isBillableReport: 'N',
          selectedRows: [],
          updatesToSave:[],
          ClaimBatchVisible: false
        };
      },

      computed: {
        editableGrid() {
            return this.$refs.editableGrid;
        }
      },

      methods: {

        onClickGenerateClaims() {

            let params = {
                "AdmissionRecordID": this.$route.params.recordid,
            };

            ChargeSheetService.GenerateClaims(params)
                .then((response) => {
                    if (response.status == '200') {

                        this.ClaimBatchItems = response.data;

                        this.ClaimBatchItems.forEach(element => {
                            element.dateFrom = element.dateFrom ? Utils.formatterDateToString(element.dateFrom) : null;
                            element.dateTo = element.dateTo ? Utils.formatterDateToString(element.dateTo) : null;
                        });

                        this.ClaimBatchVisible = true;
                        
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), 'NOT OK', "error");
                    }
                })
                .catch((error) => {
                    this.showMessage(this.$tc('Msg.Error'), error, "error");
                });
        },

        ValidateBatch() {
            if (this.ClaimBatchItems.length > 0) {
                this.$refs.mdClaimBatchProcessing.ProcessBatch(true);
            }
        },

        ProcessBatch() {
            if (this.ClaimBatchItems.length > 0) {
                this.$refs.mdClaimBatchProcessing.ProcessBatch(false);
            }
        },

        validationBeforePost(SD) {
            let dischargeDate = Utils.formatterDate(this.patientInfo[0].dischargeDate)
            let admissionADMITDATE = Utils.formatterDate(this.patientInfo[0].admissionADMITDATE)
            let serviceDate = Utils.formatterDate(SD)

            if (dischargeDate != '0001-01-01' &&
               serviceDate > dischargeDate) {
                this.showMessage(this.$t('ChargeSheet.ChargeSheet'),
                                 this.$t('ChargeSheet.Cannotaddchargesbeyond'),'error');
                return false
            }
            else if (serviceDate < admissionADMITDATE) {
                this.showMessage(this.$t('ChargeSheet.ChargeSheet'),
                                 this.$t('ChargeSheet.CannotaddchargesBefore'),'error');
                return false
            }
            return true
        },

        addItem() {
            this.pendingChanges = true;
        },

        onSelectRow(rows) {
            this.selectedRows = rows;
        },

        deleteItem(item) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteAllRecord'), {
                    title: this.$tc('Shared.DelRecord', 2),
                    okTitle: this.$t('Shared.TitleDeleteAll'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        if (item && item.length > 0) {
                        item.forEach(el => {
                            if (el.progcodeid != el.recordid.trim()) {
                                this.showMessage(this.$t('ChargeSheet.ChargeSheet'),
                                                 this.$t('ChargeSheet.CannotDeleteChargeSheet'),'error');
                            } else {
                                const idsToRemove =
                                this.selectedRows.length > 0
                                    ? this.selectedRows.map(row => row.recNo)
                                    : [el.recNo];

                                this.detail = this.detail.filter(row => !idsToRemove.includes(row.recNo));
                                this.selectedRows = [];
                                this.deleteAttendance(el.recNo)
                            }
                        });
                    } else {
                        if (item.progcodeid != item.recordid.trim()) {
                                this.showMessage(this.$t('ChargeSheet.ChargeSheet'),
                                                 this.$t('ChargeSheet.CannotDeleteChargeSheet'),'error');
                        } else {
                            const idsToRemove =
                            this.selectedRows.length > 0
                                ? this.selectedRows.map(row => row.recNo)
                                : [item.recNo];

                            this.detail = this.detail.filter(row => !idsToRemove.includes(row.recNo));
                            this.selectedRows = [];
                            this.deleteAttendance(item.recNo)
                        }
                    }
                    }
                });
        },


        deleteAttendance(recNo) {
            AttendancesService.delete(recNo)
                .then(() => {
                })
                .catch((error) => {
                  this.showResponseErrorMessage(error);
                });
        },

        async updateAttendance(data) {
            await AttendancesService.update(data)
                .then(() => {

                    this.pendingChanges = false;
                    setTimeout(
                        () =>
                            this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: 'success'
                            }),
                        50
                    );
                    this.GetChargeSheetDetail();
                })
                .catch((error) => {
                  this.showResponseErrorMessage(error);
                });
        },

        async insertAttendance(data) {
            await AttendancesService.insert(data)
                .then(() => {
                    this.pendingChanges = false;
                    this.GetChargeSheetDetail();
                })
                .catch((error) => {
                  this.showResponseErrorMessage(error);
                });
        },

        updateValues(rowKey) {
            const index = this.updatesToSave.findIndex(x => x.recNo.trim() == rowKey);
            const row = this.detail.find(x => x.recNo == rowKey);

            if (row.billed == 'Y') {
                this.showMessage(this.$t('ChargeSheet.ChargeSheet'),
                                 this.$t('ChargeSheet.CannotEdit'),'error');
            } else {
                this.pendingChanges = true;
                if (index === -1) {
                    this.updatesToSave.push(row);
                    return;
                } else {
                    this.updatesToSave.splice(index, 1)
                    this.updatesToSave.push(row);
                }
            }


        },

        async saveEditableGrid() {
            this.saving = true;
            let updateList =  []

            this.updatesToSave.forEach(el => {
                if (this.validationBeforePost(el.servicedate))
                    updateList.push(el)
            });

            if (await this.editableGrid.save()) {
                if (updateList && updateList.length > 0) {
                    await this.updateAttendance(updateList)
                }
            }
            else {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.InvalidFieldValuesDetected'),
                    'errorAutoHide'
                );
            }
            this.updatesToSave = []
            this.saving = false;
        },

          onClickBillReport(Billable) {
            this.isBillableReport = Billable
            this.isReportVisible = true
          },

          closeParamRepWindow() {
            this.isReportVisible = false
          },

          closeModalAddProcedures() {
            this.isAddProceduresVisible = false
          },

          onClickAddProcedures() {
            this.isAddProceduresVisible = true
          },

          onClickResetRoomCharge() {
            this.$bvModal.msgBoxConfirm(this.$t('ChargeSheet.ResetRoomChargesMsg'), {
					title: this.$t('ChargeSheet.ResetRoomCharges'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
          id: 'modal_delete_admission'
				})
          .then(value => {
            if(value){
               ChargeSheetService.ResetRoomCharge(this.$route.params.recordid)
                .then(() => {

                })
                .catch((error) => {
                  this.showResponseErrorMessage(error);
                });
            }
          })
          },

          DiscardChanges() {
            this.$router.push({
              name: "chargesheet"
            });
          },

          onClick() {

          },

          async GetPatientByCode(){
            var infoList = await this.getInfoTitle(this.$route.params.id);
            if(infoList.length > 0){
              this.PatientTitle.programName = '';
              this.PatientTitle.admitDate = '';
              this.PatientTitle.dischargeDate = '';

              const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

              if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
              if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
              if (age) this.PatientTitle.age = age;
              if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;
            }
          },

          pageChanged(page){
            this.currentPage = page;
            this.GetChargeSheetFilteredList();
          },

          PerPageFunction(perpage){
            this.perPage = perpage;
            this.currentPage = 1;
            this.GetChargeSheetFilteredList();
          },

          onRowSelected(){

          },

          onFiltered(){

          },

          pageSummaryChanged(page){
            this.currentSummaryPage = page;
            this.GetChargeSheetSummary();
          },

          PerPageSummaryFunction(perpage){
            this.perSummaryPage = perpage;
            this.currentSummaryPage = 1;
            this.GetChargeSheetSummary();
          },

          onRowSummarySelected(){

          },

          onSummaryFiltered(){

          },

          pageActionsChanged(page){
            this.currentActionsPage = page;
            this.GetChargeSheetActions();
          },

          PerPageActionsFunction(perpage){
            this.perActionsPage = perpage;
            this.currentActionsPage = 1;
            this.GetChargeSheetActions();
          },

          onRowActionsSelected(){

          },

          onActionsFiltered(){

          },

          pageDetailChanged(page){
            this.currentDetailPage = page;
            this.GetChargeSheetDetail();
          },

          PerPageDetailFunction(perpage){
            this.perDetailPage = perpage;
            this.currentDetailPage = 1;
            this.GetChargeSheetDetail();
          },

          onRowDetailSelected(rows){
            this.detailSelected = rows;
            this.showCMD = rows.length > 0;
          },

          onDetailFiltered(){

          },

          DateFromChange(){

          },

          DateToChange(){

          },


          async GetChargeSheetFilteredList() {
                  this.$emit('load', true)
                  let params = {
                    "SearchCriteria":this.SearchCriteria,
                    "PageSize":  this.perPage,
                    "PageNumber" : this.currentPage,
                    "DateFrom": Utils.formatterToISO(this.DateFrom),
                    "DateTo": Utils.formatterToISO(this.DateTo),
                    "ProgramCode": this.ProgramModel && this.ProgramModel.code ? this.ProgramModel.code : null,
                    "Status": this.StatusModel && this.StatusModel.code ? this.StatusModel.code : null,
                  }
                  await ChargeSheetService.getAll(params)

                 .then((response) => {
                    if(response.status == '200'){
                        this.items = response.data;

                        let headerString = response.headers["x-pagination"];
                        this.Header = JSON.parse(headerString);
                        this.totalRows = this.Header.TotalCount;

                        this.items.forEach(element => {
                          element.admitdate = element.admitdate ? Utils.formatterDateToString(element.admitdate) : null;
                          element.dischargedate = element.dischargedate && element.dischargedate != '0001-01-01T00:00:00'  ? Utils.formatterDateToString(element.dischargedate) : null;
                          element.maxServiceDate = element.maxServiceDate  && element.maxServiceDate != '0001-01-01T00:00:00' ? Utils.formatterDateToString(element.maxServiceDate) : null;
                          element.minServiceDate = element.minServiceDate  && element.minServiceDate != '0001-01-01T00:00:00' ? Utils.formatterDateToString(element.minServiceDate) : null;

                          element.admittime = element.admittime ? Utils.formatTime(element.admittime) : null;
                          element.dischargetime = element.dischargetime && element.dischargetime != '0001-01-01T00:00:00' ? Utils.formatTime(element.dischargetime) : null;
                         })

                      }
                      this.$emit('load', false);
                  }).catch(error => {
                    this.$emit('load', false);
                    if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
        },

        async GetChargeSheetPatientInfo() {
                  this.$emit('load', true)
                  let params = {
                    "AdmissionRecordID":this.$route.params.recordid,
                  }
                  await ChargeSheetService.getChargeSheetPatientInfo(params)

                 .then((response) => {
                    if(response.status == '200'){
                        this.patientInfo = response.data;
                        this.patientCode = this.patientInfo[0].patientCode
                        this.patientAddress = this.patientInfo[0].address_1
                        this.patientZIP = this.patientInfo[0].zip
                        this.patientCity = this.patientInfo[0].city
                        this.patientState = this.patientInfo[0].state
                        this.facilityCode = this.patientInfo[0].insuranceCode
                        this.primInsurance = this.patientInfo[0].primInsuranceNo
                        this.insuranceCompany = this.patientInfo[0].primInsuranceName
                        this.gender = this.patientInfo[0].sex
                        this.maskedSSN = this.patientInfo[0].maskedSSN
                        this.doctorName = this.patientInfo[0].doctorName
                        this.roomNo = this.patientInfo[0].roomNo
                        this.primDiag = this.patientInfo[0].primDiag
                        this.dayinIPF = this.patientInfo[0].dayinIPF
                        this.admissionRecordID = this.$route.params.recordid
                        this.chartNo = this.patientInfo[0].chartNo
                        this.AdmDate = Utils.formatterDateToString(this.patientInfo[0].admitDate)
                        this.AdmTime = Utils.formatTime(this.patientInfo[0].admitDate)
                        this.DiscDate = Utils.formatterDateToString(this.patientInfo[0].dischargeDate)
                        this.DiscTime = Utils.formatTime(this.patientInfo[0].dischargeDate)
                    }
                      this.$emit('load', false);
                  }).catch(error => {
                    this.$emit('load', false);
                    if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
        },

        async GetChargeSheetSummary() {
                  this.$emit('load', true)
                  let params = {
                    "AdmissionRecordID":this.$route.params.recordid,
                    "PageSize":  this.perSummaryPage,
                    "PageNumber" : this.currentSummaryPage,
                  }
                  await ChargeSheetService.getChargeSheetSummary(params)

                 .then((response) => {
                    if(response.status == '200'){
                        this.summary = response.data;

                        let headerString = response.headers["x-pagination"];
                        this.HeaderSummary = JSON.parse(headerString);
                        this.totalSummaryRows = this.HeaderSummary.TotalCount;

                        this.summary.forEach(item => {
                          item.dateFrom = item.dateFrom ? Utils.formatterDateToString(item.dateFrom) : null;
                          item.dateTo = item.dateTo ? Utils.formatterDateToString(item.dateTo) : null;
                         })
                    }
                      this.$emit('load', false);
                  }).catch(error => {
                    this.$emit('load', false);
                    if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
        },

        async GetChargeSheetActions() {
                  this.$emit('load', true)
                  let params = {
                    "PatientCode":this.patientInfo[0].patientCode,
                    "AdmissionGroupCreationId":this.patientInfo[0].groupCreationID,
                    "AdmissionDateFrom":Utils.formatterDateToString(this.patientInfo[0].admissionADMITDATE),
                    "AdmissionDateTo": Utils.IsValidFieldDate(this.patientInfo[0].admissionDISCHARGEDATE) ? Utils.formatterDateToString(this.patientInfo[0].admissionDISCHARGEDATE) : ' ',
                    "PageSize":  this.perActionsPage,
                    "PageNumber" : this.currentActionsPage,
                  }
                  await ChargeSheetService.getChargeSheetActions(params)

                 .then((response) => {
                    if(response.status == '200'){
                        this.actions = response.data;

                        let headerString = response.headers["x-pagination"];
                        this.HeaderActions = JSON.parse(headerString);
                        this.totalActionsRows = this.HeaderActions.TotalCount;

                        this.actions.forEach(item => {
                          item.actionDate = item.actionDate ? Utils.formatterDateTimeToString(item.actionDate) : null;
                          item.dateFrom = item.dateFrom ? Utils.formatterDateToString(item.dateFrom) : null;
                          item.dateTo = Utils.IsValidFieldDate(item.dateTo) ? Utils.formatterDateToString(item.dateTo) : null;
                         })
                    }
                      this.$emit('load', false);
                  }).catch(error => {
                    this.$emit('load', false);
                    if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
        },

        indexOfFromItemRowKey(rowKey) {
            const key = JSON.parse(rowKey);
            return this.detail.findIndex(x =>
                x.recNo.trim() == key
            )
        },

        onDetailCellEditComplete(data) {
            const rowIndex = this.indexOfFromItemRowKey(data.rowKey);

            if (rowIndex !== -1) {
                this.detail[rowIndex][data.columnKey] = data.value;
            }

            if (data.lookupInfo) {
                if (data.columnKey === 'coursecode') {
                    this.detail[rowIndex]['description'] = data.lookupInfo.description;
                }
                else if (data.columnKey === 'roomno') {
                    this.$set(this.detail[rowIndex], 'roomDescription', data.lookupInfo.description);
                }
            }

            this.updateValues(data.rowKey)
        },

        async appendDetailRows(rows) {

            if (this.validationBeforePost(rows[0].servicedate)) {
                rows.forEach(row => {
                    this.detail.push({ row });
                });

                rows[0].diagnosticcode = this.patientInfo[0].primDiag
                rows[0].recordid = this.$route.params.recordid
                rows[0].patientcode = this.$route.params.id
                rows[0].progcode = this.patientInfo[0].programcode

                this.insertAttendance(rows[0])

                return true;
            } else {
                return false
            }
        },

        onDetailSearch(searchText) {
            this.DetailSearchCriteria = searchText;
            this.currentDetailPage = 1;
            this.GetChargeSheetDetail();
        },

        async GetChargeSheetDetail() {
                  this.$emit('load', true)
                  let params = {
                    "AdmissionRecordID":this.$route.params.recordid,
                    "PageSize":  this.perDetailPage,
                    "PageNumber" : this.currentDetailPage,
                    "SearchCriteria": this.DetailSearchCriteria,
                  }
                  await ChargeSheetService.getChargeSheetDetail(params)

                 .then((response) => {
                    if(response.status == '200'){
                        this.detail = response.data;

                        let headerString = response.headers["x-pagination"];
                        this.HeaderDetail = JSON.parse(headerString);
                        this.totalDetailRows = this.HeaderDetail.TotalCount;

                        this.detail.forEach(item => {
                          if (item.servicedate === '0001-01-01T00:00:00') item.servicedate = null;
                        })
                    }
                      this.$emit('load', false);
                  }).catch(error => {
                    this.$emit('load', false);
                    if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  })
        },

        ClaimBatchOnCancel() {
            this.ClaimBatchVisible = false;
        }
      },

      created() {
      },

      async mounted(){
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
          case 'L0R1':
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
          case 'L1R0':
          case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
          default:
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        await this.GetPatientByCode();
        await this.GetChargeSheetPatientInfo()
        await this.GetChargeSheetSummary()
        await this.GetChargeSheetActions()
        await this.GetChargeSheetDetail()
      }
    };
</script>
